import { render, staticRenderFns } from "./MasterPackage.vue?vue&type=template&id=472ed6bc"
import script from "./MasterPackage.js?vue&type=script&lang=js&external"
export * from "./MasterPackage.js?vue&type=script&lang=js&external"
import style0 from "./MasterPackage.vue?vue&type=style&index=0&id=472ed6bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports